import { AlertCircle, ExternalLink } from 'lucide-react'
import { Link } from 'react-router-dom'

import { Alert, AlertDescription } from '@/components/ui/alert'
import {
  AUTOMATION_TEMPLATE_UI,
  META_TEMPLATE_ALERT_CLASS,
} from '@/components/settings/automationTemplatesUi'

type AutomationSettingsLinkAlertProps = {
  lang: string
  message: string
}

export function AutomationSettingsLinkAlert({ lang, message }: AutomationSettingsLinkAlertProps) {
  return (
    <Alert className={META_TEMPLATE_ALERT_CLASS}>
      <AlertCircle className="h-4 w-4" />
      <AlertDescription className="flex flex-wrap items-center gap-x-2 gap-y-1">
        <span>{message}</span>
        <Link
          to={`/${lang}/settings`}
          className="inline-flex items-center gap-1 font-medium text-primary underline-offset-4 hover:underline"
        >
          {AUTOMATION_TEMPLATE_UI.settingsLinkLabel}
          <ExternalLink className="h-3.5 w-3.5" />
        </Link>
      </AlertDescription>
    </Alert>
  )
}
